import React from 'react';
import classnames from 'classnames';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { styleFromWidthHeight } from '../../_helpers';
import s from './Literature.scss';
var typeMap = {
    ANTFART: 'antfart',
    NANO: 'nano',
    SMALL: 'small',
    MEDIUM: 'medium',
    BIG: 'big',
};
// not sure about the correct approach, I used the comparison with the area, as there were no breakpoints for height and width
var typeSizeMap = {
    ANTFART: 66,
    NANO: 150,
    SMALL: 214,
    MEDIUM: 250,
    BIG: 280,
};
function getTypeBasedOnSize(size) {
    if (size <= typeSizeMap.ANTFART) {
        return typeMap.ANTFART;
    }
    if (size <= typeSizeMap.NANO) {
        return typeMap.NANO;
    }
    if (size <= typeSizeMap.SMALL) {
        return typeMap.SMALL;
    }
    if (size > typeSizeMap.BIG) {
        return typeMap.BIG;
    }
    return typeMap.MEDIUM;
}
export var LiteratureDumbView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, useTextlessMode = _a.useTextlessMode, _b = _a.responsive, responsive = _b === void 0 ? true : _b;
    var type = getTypeBasedOnSize(height);
    var title = deviation.title;
    var style = styleFromWidthHeight({ width: width, height: height }, responsive);
    var isBigEnough = (style.height || 0) > typeSizeMap.ANTFART;
    return (React.createElement("div", { className: classnames(s['root'], s[type]), style: style },
        React.createElement(LiteratureCoverLetter, { title: title, isBigEnough: isBigEnough }),
        !useTextlessMode && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['text-content'] }, deviation.textContent && deviation.textContent.excerpt)))));
};
LiteratureDumbView.displayName = 'LiteratureDumbView';
export default LiteratureDumbView;
//# sourceMappingURL=Literature.js.map